import { z } from 'zod'

import type { MapItem } from 'src/shared/schemas/utils'

import type { Profession } from './profession'

export const expertiseMap: Record<Profession, Partial<Record<Expertise, MapItem>>> = {
  mortgage_loan_officer: {
    fha_loans: { label: 'FHA Loans' },
    va_loans: { label: 'VA Loans' },
    non_qm_loans: { label: 'Non-QM Loans' },
    jumbo_loans: { label: 'Jumbo Loans' },
    usda_loans: { label: 'USDA Loans' },
    conventional_loans: { label: 'Conventional Loans' },
    refinancing_specialist: { label: 'Refinancing Specialist' },
  },
  real_estate_agent: {
    residential_sales: { label: 'Residential Sales' },
    commercial_sales: { label: 'Commercial Sales' },
    luxury_real_estate: { label: 'Luxury Real Estate' },
    investment_properties: { label: 'Investment Properties' },
    reo_foreclosure_specialist: { label: 'REO/Foreclosure Specialist' },
    property_management: { label: 'Property Management' },
  },
  real_estate_insurance_broker: {
    homeowners_insurance: { label: 'Homeowner’s Insurance' },
    landlord_insurance: { label: 'Landlord Insurance' },
    commercial_property_insurance: { label: 'Commercial Property Insurance' },
    title_insurance: { label: 'Title Insurance' },
    flood_insurance: { label: 'Flood Insurance' },
    condo_insurance: { label: 'Condo Insurance' },
    liability_insurance: { label: 'Liability Insurance' },
  },
  contractor: {
    general_contracting: { label: 'General Contracting' },
    expertise_contracting: { label: 'Expertise Contracting' },
    restoration_services: { label: 'Restoration Services' },
    green_construction: { label: 'Green Construction' },
    commercial: { label: 'Commercial' },
    residential: { label: 'Residential' },
  },
  real_estate_attorney: {
    residential_real_estate_law: { label: 'Residential Real Estate Law' },
    commercial_real_estate_law: { label: 'Commercial Real Estate Law' },
    title_law: { label: 'Title Law' },
    foreclosure_short_sale: { label: 'Foreclosure and Short Sale' },
    landlord_tenant_law: { label: 'Landlord-Tenant Law' },
  },
  property_inspector: {
    residential_inspection: { label: 'Residential Inspection' },
    commercial_inspection: { label: 'Commercial Inspection' },
    environmental_hazard_inspection: { label: 'Environmental Hazard Inspection' },
    expertise_inspections: { label: 'Expertise Inspections' },
  },
  real_estate_appraiser: {
    residential_appraisal: { label: 'Residential Appraisal' },
    commercial_appraisal: { label: 'Commercial Appraisal' },
    investment_property_appraisal: { label: 'Investment Property Appraisal' },
    land_appraisal: { label: 'Land Appraisal' },
    luxury_property_appraisal: { label: 'Luxury Property Appraisal' },
  },
  title_company_rep: {
    residential_title_services: { label: 'Residential Title Services' },
    commercial_title_services: { label: 'Commercial Title Services' },
    exchange_services: { label: '1031 Exchange Services' },
    lien_search_release: { label: 'Lien Search and Release' },
  },
}

export const expertiseSchema = z.enum([
  'fha_loans',
  'va_loans',
  'non_qm_loans',
  'jumbo_loans',
  'usda_loans',
  'conventional_loans',
  'refinancing_specialist',
  'residential_sales',
  'commercial_sales',
  'luxury_real_estate',
  'investment_properties',
  'reo_foreclosure_specialist',
  'property_management',
  'homeowners_insurance',
  'landlord_insurance',
  'commercial_property_insurance',
  'title_insurance',
  'flood_insurance',
  'condo_insurance',
  'liability_insurance',
  'general_contracting',
  'expertise_contracting',
  'restoration_services',
  'green_construction',
  'commercial',
  'residential',
  'residential_real_estate_law',
  'commercial_real_estate_law',
  'title_law',
  'foreclosure_short_sale',
  'landlord_tenant_law',
  'residential_inspection',
  'commercial_inspection',
  'environmental_hazard_inspection',
  'expertise_inspections',
  'residential_appraisal',
  'commercial_appraisal',
  'investment_property_appraisal',
  'land_appraisal',
  'luxury_property_appraisal',
  'residential_title_services',
  'commercial_title_services',
  'exchange_services',
  'lien_search_release',
])

export type Expertise =
  | 'fha_loans'
  | 'va_loans'
  | 'non_qm_loans'
  | 'jumbo_loans'
  | 'usda_loans'
  | 'conventional_loans'
  | 'refinancing_specialist'
  | 'residential_sales'
  | 'commercial_sales'
  | 'luxury_real_estate'
  | 'investment_properties'
  | 'reo_foreclosure_specialist'
  | 'property_management'
  | 'homeowners_insurance'
  | 'landlord_insurance'
  | 'commercial_property_insurance'
  | 'title_insurance'
  | 'flood_insurance'
  | 'condo_insurance'
  | 'liability_insurance'
  | 'general_contracting'
  | 'expertise_contracting'
  | 'restoration_services'
  | 'green_construction'
  | 'commercial'
  | 'residential'
  | 'residential_real_estate_law'
  | 'commercial_real_estate_law'
  | 'title_law'
  | 'foreclosure_short_sale'
  | 'landlord_tenant_law'
  | 'residential_inspection'
  | 'commercial_inspection'
  | 'environmental_hazard_inspection'
  | 'expertise_inspections'
  | 'residential_appraisal'
  | 'commercial_appraisal'
  | 'investment_property_appraisal'
  | 'land_appraisal'
  | 'luxury_property_appraisal'
  | 'residential_title_services'
  | 'commercial_title_services'
  | 'exchange_services'
  | 'lien_search_release'
